<my-content placeholder="navigation">

    <div>&nbsp;</div>
    <div class=" col-sm-12 lefticonD paddingless"><label>{{pageHeader}}</label>
    </div>
    <div>&nbsp;</div>
    <div class=" col-sm-12">
        <form #AddFinalVerdict="ngForm" [formGroup]="addFormFinalVedict"
            (ngSubmit)="onFinalVerdictSubmit(AddFinalVerdict.value);">
            <fieldset style="margin-left: 4%; margin-right: 4%; border: 1px solid #ccc;">
                <table style="margin-top: 10px; margin-right: 15px;">
                    <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                        <td width="15%">{{this.RefNo}}</td>
                        <td width="35%">
                            <div class="col-sm-10">
                                <input readonly type="text" class="form-control" formControlName="refno"
                                    placeholder="Case Number" ngMode value="" name="refno" id="refno" />
                            </div>
                        </td>
                        <td width="15%">{{CaptionJurisdiction}}</td>
                        <td width="35%">
                            <select class="form-control" formControlName="Jurisdiction">
                                <option value="0" selected>[Not Selected]</option>
                                <option *ngFor="let mDtl of Jurisdiction " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                        <td width="15%">Filling Party</td>
                        <td width="35%">
                            <div class="col-sm-12 paddingless"
                                *ngFor="let feFD of FetchExistingFillingParty; let i=index ">
                                <div class="col-sm-12">
                                    <b class="col-sm-5"> {{i+1}} )
                                    </b> <span class="col-sm-6">{{feFD.Name}}
                                    </span>
                                </div>
                                <div class="col-sm-12">
                                    <hr>
                                </div>
                            </div>
                        </td>
                        <td width="15%">Opposite Party</td>
                        <td width="35%">
                            <div class="col-sm-12 paddingless"
                                *ngFor="let feOP of FetchExistingOppositeParty; let i=index ">
                                <div class="col-sm-12">
                                    <b class="col-sm-5"> {{i+1}} )
                                    </b> <span class="col-sm-6">{{feOP.Name}}
                                    </span>


                                </div>
                                <div class="col-sm-12">
                                    <hr>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                        <td width="15%">State</td>
                        <td width="35%">
                            <div class="col-sm-10">
                                <!-- <input type="text" class="form-control" placeholder="State" required="required" /> -->


                                <select class="form-control " formControlName="State"
                                    (change)="onStateSelect($event.target.value)">
                                    <option value="0">[Not Selected] </option>
                                    <option *ngFor="let mDtl of State " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}
                                    </option>
                                </select>

                            </div>
                        </td>
                        <td width="15%">City</td>
                        <td width="35%">


                            <select class="form-control " formControlName="City"
                                (change)="onCitySelect($event.target.value)">
                                <option value="0" selected>[Not Selected]</option>
                                <option *ngFor="let mDtl of City " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                        <td width="15%">Category</td>
                        <td width="35%">
                            <div class="col-sm-10">
                                <select class="form-control " formControlName="Category"
                                    (change)="onCategorySelect($event.target.value)">
                                    <option value="0" selected>[Not Selected]</option>
                                    <option *ngFor="let mDtl of Category " value="{{mDtl.hdID}}">{{mDtl.MainDescr}}
                                    </option>
                                </select>

                            </div>
                        </td>
                        <td width="15%">Sub Category</td>
                        <td width="35%">
                            <select class="form-control" formControlName="SubCategory">
                                <option value="0" selected>[Not Selected]</option>
                                <option *ngFor="let mDtl of SubCategory " value="{{mDtl.hdID}}">
                                    {{mDtl.MainDescr}}</option>
                            </select>
                        </td>
                    </tr>




                    <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>


                        <td width="15%">Decision</td>
                        <td width="35%">
                            <div class="col-sm-10">
                                <select class="form-control" formControlName="Decision">
                                    <option value="0">[Not Selected]</option>
                                    <option value="1">In Our Favour</option>
                                    <option value="2">Against US</option>
                                </select>
                            </div>
                        </td>


                        <td width="15%">Payment Date</td>
                        <td width="35%">
                            <div class="col-sm-12">

                                <div class="col-sm-6">
                                    <mat-form-field class="fullwidth">

                                        <input matInput [min]="minDate" formControlName="DateofFinalvedictFromTime"
                                            [max]="maxDate" [matDatepicker]="picker" placeholder="Choose a date"
                                            class="">

                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">

                                    <mat-form-field class="fullwidth">

                                        <input matInput [min]="minDate" formControlName="DateofFinalvedictToTime"
                                            [max]="maxDate" [matDatepicker]="picker1" placeholder="Choose a date"
                                            class="">

                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>

                                </div>



                            </div>


                        </td>
                    </tr>

                    <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                        <td width="15%">Judgements Implications</td>
                        <td width="35%">
                            <div class="col-sm-10">
                                <!-- <select class="form-control" formControlName="JudgementsImplications">
                                    <option value="0" selected>[Not Selected]</option>
                                    <option *ngFor="let mDtl of ManagementDecision " value="{{mDtl.hdID}}">
                                        {{mDtl.MainDescr}}
                                    </option>
                                </select> -->

                                <!-- <ng-multiselect-dropdown [placeholder]="'Select Your Judgements Implications'"
                                    [settings]="dropdownSettingsJudgements" [data]="dropdownListJudgements" 
                                    (onSelect)="onManagerDecisionSelectJudgements($event)"
                                   
                                    [(ngModel)]="SelectedItemsJudgement"
                                    formControlName="JudgementsImplications">
                                </ng-multiselect-dropdown> -->

                                <textarea type="text" readonly formControlName="JudgementsImplications"
                                class="form-control TextareafullSize"></textarea>
                            </div>
                        </td>

                        <td width="15%">Remarks</td>
                        <td width="35%">

                            <textarea type="text" readonly formControlName="Remarks"
                                class="form-control TextareafullSize"></textarea>
                        </td>

                    </tr>

                    <tr>
                        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>


                        <td width="15%">Management Decision</td>
                        <td width="35%">
                            <div class="col-sm-10">
                                <!-- <ng-multiselect-dropdown [placeholder]="'Select Your Management Decision'"
                                    [settings]="dropdownSettings" [data]="dropdownList" [(ngModel)]="SelectedItems"
                                    (onSelect)="onManagerDecisionSelect($event)" (onSelectAll)="onSelectAll($event)"
                                    (onDeSelect)="onManagerDecisionDeSelect($event)"
                                    formControlName="ManagementDecision">
                                </ng-multiselect-dropdown> -->
<!-- kks -->
                                <!-- <ng-multiselect-dropdown [placeholder]="'Select Your Management Decision'"
                                [settings]="dropdownSettings" [data]="dropdownList"
                                (onSelect)="onManagerDecisionSelect($event)"
                                (onDeSelect)="onManagerDecisionDeSelect($event)"
                                formControlName="ManagementDecision">
                            </ng-multiselect-dropdown> -->
                            <ng-select
                                [items]="dropdownList"
                                bindLabel="name"
                                bindValue="id"
                                [multiple]="true"
                                placeholder="Select Management Decision"
                                formControlName="ManagementDecision"
                                (change)="onManagerDecisionSelectEvent($event)"
                                (remove)="onManagerDecisionDeSelect($event)"
                            >
                            </ng-select>


                            </div>
                        </td>
                        <td width="15%">Amount</td>
                        <td width="35%">
                            <input type="number" readonly class="form-control" formControlName="Amount"
                                placeholder="Amount" />
                        </td>
                    </tr>
                </table>

                <div class="col-sm-12">


                    <div class="col-sm-6">
                        <div *ngIf="this.RequestFVCFromUploadFile ==='7'"
                            style="margin-bottom: 10px; margin-top: 10px;">
                            <table class="fullwidth LMtable" style="width: 100%;">
                                <tr>
                                    <th>S.No.</th>

                                    <th>Files</th>

                                </tr>
                                <tr style="border: lightgray solid 1px "
                                    *ngFor="let fsD of factsheetDetail; let i=index ">
                                    <td align="center">{{i+1}}</td>

                                    <td>
                                        <table>
                                            <tr *ngFor="let fsDFile of fsD.attachment; let i=index">
                                                <td><a
                                                        href={{DownloadURL}}{{fsDFile.DownloadPath}}>{{fsDFile.DisplayName}}</a>
                                                </td>

                                            </tr>
                                        </table>
                                    </td>

                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="col-sm-6">
                    </div>
                </div>

                <!-- Payment of Penalty Start -->
                <div *ngIf="this.PaymentofPenaltyRequestFrom == '1'">
                    <h4 style="margin-left: 27px; margin-bottom: 18px;">Payment of Penalty</h4>
                    <div class="col-sm-12">
                        <div class="col-sm-2">
                            Pending Amount
                        </div>

                        <div class="col-sm-3">
                            <input type="number" class="form-control" formControlName="PendingPaymentAmount"
                                placeholder="Amount" readonly />
                        </div>

                        <div class="col-sm-2">
                            Paid Amount
                        </div>

                        <div class="col-sm-4">
                            <input type="number" (change)="onChangeCalPayAmount($event.target.value)"
                                class="form-control" formControlName="PaymentAmount" placeholder="Amount"
                                required="required" />
                        </div>





                    </div>


                    <div class="col-sm-12" style="margin-top: 12px;">

                        <div class="col-sm-2">
                            Balance Amount
                        </div>

                        <div class="col-sm-3">
                            <input type="number" class="form-control" formControlName="BalanceAmount"
                                placeholder="Amount" readonly />
                        </div>



                        <div class="col-sm-2">
                            Responsible Person
                        </div>

                        <div class="col-sm-4">
                            <!-- <input type="text" readonly class="form-control" formControlName="PaymentResponsiblePerson"
                                placeholder="Responsible Person" required="required" /> -->
                                <select class="form-control" formControlName="PaymentResponsiblePerson">
                                    <option value="0" selected>[Not Selected]</option>
                                    <option *ngFor="let mDtl of PaymentResponsiblePerson " value="{{mDtl.ID}}">
                                        {{mDtl.USERNAME}}
                                    </option>
                                </select>
                        </div>



                    </div>
                    <div class="col-sm-12" style="margin-top: 12px;">

                        <div class="col-sm-2">
                            Payment to made in favour of
                        </div>

                        <div class="col-sm-3">
                            <input type="text" readonly class="form-control" formControlName="Paymenttomadeinfavourof"
                                placeholder="Payment to made in favour of" required="required" />
                        </div>
                        <div class="col-sm-2">
                            Remarks
                        </div>

                        <div class="col-sm-4">
                            <textarea type="text" formControlName="PaymentRemarks"
                                class="form-control TextareafullSize"></textarea>
                        </div>
                    </div>

                    <div class="col-sm-12" style="margin-top: 12px;">
                        <div class="col-sm-2">
                            Paid Payment Date
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field class="fullwidth">

                                <input matInput [min]="minDate" formControlName="DateofFinalVedictPaymentFromTime"
                                    [max]="maxDate" [matDatepicker]="picker4" placeholder="Choose from date" class="">

                                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                <mat-datepicker #picker4></mat-datepicker>
                            </mat-form-field>
                            
                        </div>
                        <div class="col-sm-2">
                            Attachement
                        </div>

                        <div class="col-sm-3">
                            <input type='file' formControlName="browseFiles" (change)="onSelectFile($event)" multiple>
                        </div>


                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <div *ngIf="this.RequestFromUploadFile==='1'">
                                    <table class="fullwidth LMtable" style="margin-left:-15px;">
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Files</th>
                                        </tr>
                                        <tr style="border: lightgray solid 1px "
                                            *ngFor="let fsD of factsheetDetailPayment; let i=index ">
                                            <td align="center">{{i+1}}</td>
                                            <td>
                                                <table>
                                                    <tr *ngFor="let fsDFile of fsD.attachment; let i=index">
                                                        <td><a
                                                                href={{DownloadURL}}{{fsDFile.DownloadPath}}>{{fsDFile.DisplayName}}</a>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-6">

                            </div>

                        </div>

                    </div>
                    <!--Payment History-->
                    <div class="col-sm-12" style="margin-top: 10px;" *ngIf="this.tblPaymentofPenalty==='1'">
                        <ul class="nav nav-tabs" style="margin-left: 13px; margin-right: 15px;">
                            <li class="active"><a data-toggle="tab" href="#Fact"><b>Payment History</b></a></li>
                        </ul>
                    </div>
                    <div class="col-sm-12" style="margin-bottom: 10px;">
                        <div id="Fact" class="tab-pane fade in active" *ngIf="this.tblPaymentofPenalty==='1'">
                            <!--Fact Sheet Form Start-->

                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <table class="fullwidth LMtable" style="margin-left:-16px;">
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Payment Date</th>
                                            <th>Amount</th>
                                        </tr>
                                        <tr style="border: lightgray solid 1px "
                                            *ngFor="let FNHD of fetchPaymentData; let i=index ">
                                            <td align="center">{{i+1}}</td>
                                            <td>
                                                {{FNHD.PaymentDate}}
                                            </td>
                                            <td>{{FNHD.PaymentAmount}}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-sm-6">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <!--Payment History End-->
                </div>
                <!-- END -->
                <!-- Recovery of Amount Start -->

                <div *ngIf="this.RecoveryofAmountRequestFrom == '2'">
                    <h4 style="margin-left: 27px; margin-bottom: 18px;">Recovery of Amount</h4>

                    <div class="col-sm-12">

                        <div class="col-sm-2">
                            Pending Amount
                        </div>

                        <div class="col-sm-3">
                            <input type="number" class="form-control" formControlName="PendingRecoveryAmount"
                                placeholder="Amount" readonly />
                        </div>

                        <div class="col-sm-2">
                            Paid Recovery Amount
                        </div>

                        <div class="col-sm-4">
                            <input type="number" class="form-control"
                                (change)="onChangeCalRecAmount($event.target.value)" formControlName="RecoverAmount"
                                placeholder="Amount" required="required" />
                        </div>
                    </div>

                    <div class="col-sm-12" style="margin-top: 12px;">
                        <div class="col-sm-2">
                            Balance Amount
                        </div>
                        <div class="col-sm-3">
                            <input type="number" class="form-control" formControlName="RecoveryBalanceAmount"
                                placeholder="Amount" readonly />
                        </div>
                        <div class="col-sm-2">
                            Responsible Person
                        </div>
                        <div class="col-sm-4">
                            <!-- <input type="text" readonly class="form-control" formControlName="RecoveryResponsiblePerson"
                                placeholder="Responsible Person" required="required" /> -->

                                <select class="form-control" formControlName="RecoveryResponsiblePerson">
                                    <option value="0" selected>[Not Selected]</option>
                                    <option *ngFor="let mDtl of RecoveryResponsiblePerson " value="{{mDtl.ID}}">
                                        {{mDtl.USERNAME}}
                                    </option>
                                </select>
                        </div>



                        <div class="col-sm-12" style="margin-top: 12px;">
                            <div class="col-sm-2">
                                Recovery Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </div>
                            <div class="col-sm-3">
                                <mat-form-field class="fullwidth">
                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictRecoveryFromTime"
                                        [max]="maxDate" [matDatepicker]="picker6" placeholder="Choose from date"
                                        class="">
                                    <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                    <mat-datepicker #picker6></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-2">
                                Remarks

                            </div>

                            <div class="col-sm-4">
                                <textarea type="text" formControlName="RecoveryRemarks"
                                    class="form-control TextareafullSize"></textarea>
                            </div>
                        </div>





                        <div class="col-sm-12" style="margin-top: 12px;">
                            <div class="col-sm-2">
                                Attachement
                            </div>

                            <div class="col-sm-3">
                                <input type='file' formControlName="RecoverybrowseFiles"
                                    (change)="onSelectFileRecovery($event)" multiple>
                            </div>
                        </div>


                        <tr>
                            <div *ngIf="this.RequestRecoveryUploadFile==='2'">
                                <table class="fullwidth LMtable">
                                    <tr>
                                        <th>S.No.</th>

                                        <th>Files</th>

                                    </tr>
                                    <tr style="border: lightgray solid 1px "
                                        *ngFor="let fsD of RecoveryfactsheetDetailPayment; let i=index ">
                                        <td align="center">{{i+1}}</td>

                                        <td>
                                            <table>
                                                <tr *ngFor="let fsDFile of fsD.attachment; let i=index">
                                                    <td><a
                                                            href={{DownloadURL}}{{fsDFile.DownloadPath}}>{{fsDFile.DisplayName}}</a>
                                                    </td>

                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </tr>
                    </div>
                    <div class="col-sm-12" *ngIf="this.tblRecoveryofPenalty==='2'">
                        <ul class="nav nav-tabs" style="margin-left: 13px; margin-right: 15px;">
                            <li class="active"><a data-toggle="tab" href="#Recovery"><b>Payment History</b></a></li>
                        </ul>
                    </div>
                    <div class="col-sm-12">
                        <div id="Recovery" class="tab-pane fade in active" *ngIf="this.tblRecoveryofPenalty==='2'">
                            <!--Fact Sheet Form Start-->

                            <div class="col-sm-12">
                                <div class="col-sm-12">&nbsp;</div>
                                <table class="fullwidth LMtable">
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Recovery Date</th>
                                        <th>Amount</th>
                                    </tr>
                                    <tr style="border: lightgray solid 1px "
                                        *ngFor="let FNHD of fetchRecoveryData; let i=index ">
                                        <td align="center">{{i+1}}</td>
                                        <td>
                                            {{FNHD.PaymentDate}}
                                        </td>
                                        <td>{{FNHD.PaymentAmount}}</td>
                                    </tr>
                                </table>

                            </div>
                        </div>

                    </div>
                    <!--Payment History End-->
                </div>

                <!-- END -->

                <div *ngIf="this.ComplianceofComplyRequestFrom == '3'" style="margin-top: 12px;">

                    <h4 style="margin-left: 27px; margin-bottom: 18px;">Comply with Compliane</h4>

                    <div class="col-sm-12">
                        <div class="col-sm-2">
                            Type of Compliance
                        </div>

                        <div class="col-sm-3">
                            <input type="text" class="form-control" formControlName="TypeofCompliance"
                                placeholder="Type of Compliance" required="required" />
                        </div>

                        <div class="col-sm-2">
                            Responsible Person
                        </div>

                        <div class="col-sm-4">
                            <!-- <input type="text" class="form-control" formControlName="ComplianceResponsiblePerson"
                                placeholder="Responsible Person" required="required" /> -->

                                <select class="form-control" formControlName="ComplianceResponsiblePerson">
                                    <option value="0" selected>[Not Selected]</option>
                                    <option *ngFor="let mDtl of ComplianceResponsiblePerson " value="{{mDtl.ID}}">
                                        {{mDtl.USERNAME}}
                                    </option>
                                </select>
                        </div>
                    </div>
                    <div class="col-sm-12" style="margin-top: 12px;">
                        <div class="col-sm-2">
                            <br />
                            Time Period
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field class="fullwidth">

                                <input matInput [min]="minDate" formControlName="DateofFinalVedictComplianceFromTime"
                                    [max]="maxDate" [matDatepicker]="picker8" placeholder="Choose From date" class="">

                                <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
                                <mat-datepicker #picker8></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-2">
                            <mat-form-field class="fullwidth">

                                <input matInput [min]="minDate" formControlName="DateofFinalVedictComplianceToTime"
                                    [max]="maxDate" [matDatepicker]="picker9" placeholder="Choose To date" class="">

                                <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
                                <mat-datepicker #picker9></mat-datepicker>
                            </mat-form-field>
                        </div>



                        <div class="col-sm-4">
                            Remarks
                            <textarea type="text" formControlName="ComplianceRemarks"
                                class="form-control TextareafullSize"></textarea>
                        </div>


                    </div>


                    <div class="col-sm-12" style="margin-top: 12px;">
                        <div class="col-sm-2" style="margin-left: 5px;">
                            Compliy with Compliance
                        </div>

                        <div class="col-sm-3">
                            <label class="radio-inline"><input type="radio" formControlName="ComplyType"
                                    value="1">Yes</label>
                            <label class="radio-inline"><input type="radio" formControlName="ComplyType"
                                    value="2">No</label>
                        </div>
                        <div class="col-sm-2">
                            Attachement
                        </div>

                        <div class="col-sm-3">
                            <input type='file' formControlName="ComplybrowseFiles" (change)="onSelectFileComply($event)"
                                multiple>
                        </div>
                    </div>


                    <div class="col-sm-12" style="margin-top: 12px;">
                        <div class="col-sm-6">
                            <div *ngIf="this.RequestComplyUploadFile==='3'">
                                <table class="fullwidth LMtable">
                                    <tr>
                                        <th>S.No.</th>

                                        <th>Files</th>

                                    </tr>
                                    <tr style="border: lightgray solid 1px "
                                        *ngFor="let fsD of ComplyfactsheetDetailPayment; let i=index ">
                                        <td align="center">{{i+1}}</td>

                                        <td>
                                            <table>
                                                <tr *ngFor="let fsDFile of fsD.attachment; let i=index">
                                                    <td><a
                                                            href={{DownloadURL}}{{fsDFile.DownloadPath}}>{{fsDFile.DisplayName}}</a>
                                                    </td>

                                                </tr>
                                            </table>
                                        </td>

                                    </tr>
                                </table>
                            </div>

                        </div>
                    </div>

                    <tr>


                    </tr>

                </div>

                <!-- Comply With Compliance block -->
                <div class="col-sm-4" style="margin-bottom: 10px; margin-top: 10px; margin-left: 15px;">

                    <input class="btn btn-primary col-sm-12" width="110px;" type="submit" id="submitwidth" name="Update"
                        value="Update" ngmodel>
                </div>

            </fieldset>

        </form>
    </div>



</my-content>
<my-content placeholder="main">

</my-content>